import { MoonOutlined, SunOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useThemeStore } from "@/shared/store/theme.store";

export function ThemeToggle() {
	const { theme, toggleTheme } = useThemeStore();

	return (
		<Tooltip title={theme === "dark" ? "Yorug' rejim" : "Tungi rejim"}>
			<Button
				type="text"
				icon={theme === "dark" ? <SunOutlined /> : <MoonOutlined />}
				onClick={toggleTheme}
				className="text-lg"
			/>
		</Tooltip>
	);
}
